import styled from 'styled-components';
import { colors, s16, s32 } from '@ardoq/design-tokens';
import { text1 } from '@ardoq/typography';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  width: 335px;
`;

export const PlainTextContainer = styled.div`
  margin-top: ${s16};
  ${text1};
`;

export const FormContainer = styled.div`
  margin-top: ${s32};
  ${text1};
`;

export const ActionsContainer = styled.div`
  margin-top: ${s32};
  ${text1};
`;

export const FooterContainer = styled.div`
  margin-top: ${s16};
  color: ${colors.textSubtle};
  ${text1};
`;
